// extracted by mini-css-extract-plugin
module.exports = {"bb-featured-event":"bb-featured-event__xJ3XB"};